import CreatePost from './CreatePost.container';

export default CreatePost;
